import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { 
  Box, 
  CardContent, 
  Typography
} from '@mui/material';
import { 
  MoneyOff as WriteoffIcon
} from '@mui/icons-material';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { WriteoffWorklistGrid } from '../components/grids';
import { WriteoffDashboardBackButton } from '../components/commands';
import { WRITEOFF_WORKLIST_TYPES, WriteoffWorklistType } from '../../../services/WriteoffService/types/writeoffWorklistTypes';
import { STATUS_CONFIGS } from '../components/dashboard/dashboardConstants';

const WriteoffWorklist: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';
  const center = searchParams.get('center') || '';
  const type = searchParams.get('type') || '';

  // Validate type parameter
  const selectedType: WriteoffWorklistType = WRITEOFF_WORKLIST_TYPES.includes(type as WriteoffWorklistType) 
    ? (type as WriteoffWorklistType) 
    : 'Draft';

  // Get display name from status config
  const displayName = STATUS_CONFIGS[selectedType]?.displayName || selectedType;

  if (!company || !center || !type) {
    return (
      <PageContainer>
        <Box display="flex" justifyContent="center">
          <PageCard sx={{ maxWidth: 800 }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="error">
                Missing required parameters. Please specify company, center, and type to view writeoff worklist.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#64748b' }}>
                Company: {company || 'Not specified'} | Center: {center || 'Not specified'} | Type: {type || 'Not specified'}
              </Typography>
            </CardContent>
          </PageCard>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <WriteoffIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
              <Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#1e293b',
                    mb: 0.5
                  }}
                >
                  {displayName} Writeoff Worklist
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b' }}
                >
                  {company} | {center} | {displayName}
                </Typography>
              </Box>
            </Box>
            <WriteoffDashboardBackButton
              company={company}
              center={center}
            />
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            {/* Writeoff Worklist Grid */}
            <WriteoffWorklistGrid />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default WriteoffWorklist;
